import { WEBHOOK_EVENT_TYPES } from '../webhook-event-types.js';
import { getCompany, getConnector, getUserAndEventTime, getTaskAndTaskWorkflow } from './lib/index.js';
export const createPayrollDataFetchedSamplePayload = () => {
    return {
        eventType: WEBHOOK_EVENT_TYPES.PAYROLL_DATA_FETCHED,
        ...getUserAndEventTime(),
        ...getTaskAndTaskWorkflow(),
        metadata: {
            orderId: '123'
        },
        data: {
            ...getCompany(),
            ...getConnector(),
            linkedAccount: '5f7212103a40e91f95ba376d',
            payrollDataEvents: [
                'deposit-accounts-synced',
                'deposit-accounts-updated',
                'statements-synced',
                'income-synced',
                'income-updated',
                'identity-synced',
                'identity-updated',
                'employment-synced',
                'employment-updated',
                'taxes-synced',
                'timesheets-synced'
            ]
        }
    };
};
//# sourceMappingURL=payroll-data-fetched.js.map